import { render, staticRenderFns } from "./signin-as.vue?vue&type=template&id=a4ce4430&scoped=true&"
import script from "./signin-as.vue?vue&type=script&lang=js&"
export * from "./signin-as.vue?vue&type=script&lang=js&"
import style0 from "./signin-as.vue?vue&type=style&index=0&id=a4ce4430&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4ce4430",
  null
  
)

export default component.exports